import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';
export default function SelectFatStatus(props) {
    
    const [spinAtivo, setSpinAtivo] = useState(false);
    
    const [lsStatus, setLsStatus] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleStatus(codigoStatus, NomeStatus){
        props.setCdStatus(codigoStatus)
        props.setDsStatus(NomeStatus)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectFatStatus(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderStatus(){
            const {data} = await api_gateway.get('/m1/consultar/fat_fatura_status');

            if(data.dados.length > 0){
                let objetoStatus = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.cd_fat_fatura_status}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleStatus(item.cd_fat_fatura_status, item.ds_fatura_status) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.ds_fatura_status}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsStatus(objetoStatus)
            }else{
                let objetoStatus = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsStatus(objetoStatus)
            }
            setSpinAtivo(false)
        }
        renderStatus()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-Statusiner"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectFatStatus(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsStatus}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsStatus}
                </ul>
            </div>
        </Form>
    )
}